var map = {
	"./figtree-latin-italic-300-900.woff2": "./fonts/figtree-latin-italic-300-900.woff2",
	"./figtree-latin-normal-300-900.woff2": "./fonts/figtree-latin-normal-300-900.woff2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./fonts sync recursive ^\\.\\/.*$";